var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _g, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 176,
    viewBox: "0 0 221 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 221,
    height: 176,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2470 -17208C-2470 -17261 -2427.02 -17304 -2374 -17304H14568C14621 -17304 14664 -17261 14664 -17208V11686C14664 11739 14621 11782 14568 11782H-2374C-2427.02 11782 -2470 11739 -2470 11686V-17208Z",
    fill: "#EEF6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2374 -17289H14568V-17319H-2374V-17289ZM14649 -17208V11686H14679V-17208H14649ZM14568 11767H-2374V11797H14568V11767ZM-2455 11686V-17208H-2485V11686H-2455ZM-2374 11767C-2418.74 11767 -2455 11730.7 -2455 11686H-2485C-2485 11747.3 -2435.3 11797 -2374 11797V11767ZM14649 11686C14649 11730.7 14612.7 11767 14568 11767V11797C14629.3 11797 14679 11747.3 14679 11686H14649ZM14568 -17289C14612.7 -17289 14649 -17252.7 14649 -17208H14679C14679 -17269.3 14629.3 -17319 14568 -17319V-17289ZM-2374 -17319C-2435.3 -17319 -2485 -17269.3 -2485 -17208H-2455C-2455 -17252.7 -2418.74 -17289 -2374 -17289V-17319Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-240 -306C-240 -341.346 -211.346 -370 -176 -370H4039C4074.35 -370 4103 -341.346 4103 -306V9238C4103 9273.35 4074.35 9302 4039 9302H-176C-211.346 9302 -240 9273.35 -240 9238V-306Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-176 -360H4039V-380H-176V-360ZM4093 -306V9238H4113V-306H4093ZM4039 9292H-176V9312H4039V9292ZM-230 9238V-306H-250V9238H-230ZM-176 9292C-205.823 9292 -230 9267.82 -230 9238H-250C-250 9278.87 -216.869 9312 -176 9312V9292ZM4093 9238C4093 9267.82 4068.82 9292 4039 9292V9312C4079.87 9312 4113 9278.87 4113 9238H4093ZM4039 -360C4068.82 -360 4093 -335.823 4093 -306H4113C4113 -346.869 4079.87 -380 4039 -380V-360ZM-176 -380C-216.869 -380 -250 -346.869 -250 -306H-230C-230 -335.823 -205.823 -360 -176 -360V-380Z",
    fill: "#5DA5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-140 -206C-140 -241.346 -111.346 -270 -76 -270H1793C1828.35 -270 1857 -241.346 1857 -206V3314C1857 3349.35 1828.35 3378 1793 3378H-76C-111.346 3378 -140 3349.35 -140 3314V-206Z",
    fill: "#F5FBF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-76 -269H1793V-271H-76V-269ZM1856 -206V3314H1858V-206H1856ZM1793 3377H-76V3379H1793V3377ZM-139 3314V-206H-141V3314H-139ZM-76 3377C-110.794 3377 -139 3348.79 -139 3314H-141C-141 3349.9 -111.899 3379 -76 3379V3377ZM1856 3314C1856 3348.79 1827.79 3377 1793 3377V3379C1828.9 3379 1858 3349.9 1858 3314H1856ZM1793 -269C1827.79 -269 1856 -240.794 1856 -206H1858C1858 -241.899 1828.9 -271 1793 -271V-269ZM-76 -271C-111.899 -271 -141 -241.899 -141 -206H-139C-139 -240.794 -110.794 -269 -76 -269V-271Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2276.3,
    transform: "translate(-40 -170)",
    fill: "url(#paint0_linear_378_44749)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-40 -138C-40 -155.673 -25.6731 -170 -8 -170H1208C1225.67 -170 1240 -155.673 1240 -138V2083.3C1240 2100.97 1225.67 2115.3 1208 2115.3H-8.00003C-25.6731 2115.3 -40 2100.97 -40 2083.3V-138Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-40 -138C-40 -155.673 -25.6731 -170 -8 -170H1208C1225.67 -170 1240 -155.673 1240 -138V2083.3C1240 2100.97 1225.67 2115.3 1208 2115.3H-8.00003C-25.6731 2115.3 -40 2100.97 -40 2083.3V-138Z",
    fill: "url(#paint1_linear_378_44749)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_44749)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_378_44749)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 364,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.926 71.126H1.31623C-21.2809 71.126 -39.5995 52.8074 -39.5995 30.2102C-39.5995 7.61306 -21.2809 -10.7055 1.31625 -10.7055H87.4928C109.823 -10.7055 127.926 7.39692 127.926 29.7274V71.126Z",
    fill: "#007580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8315 123.267L0.915756 123.267L-40 123.267C-40 100.67 -21.6814 82.3516 0.91576 82.3516C23.5129 82.3516 41.8315 100.67 41.8315 123.267Z",
    fill: "#FF7F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8315 134.379L0.915756 134.379L-40 134.379C-40 156.976 -21.6814 175.295 0.91576 175.295C23.5129 175.295 41.8315 156.976 41.8315 134.379Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46 30.3308L179.545 30.3308L138.629 30.3308C138.629 7.73365 156.948 -10.585 179.545 -10.585C202.142 -10.585 220.46 7.73366 220.46 30.3308Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6939 86.2132L86.6096 86.2132L127.525 86.2131C127.525 108.81 109.207 127.129 86.6096 127.129C64.0125 127.129 45.6939 108.81 45.6939 86.2132Z",
    fill: "#284993"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 -69.5H1192C1196.14 -69.5 1199.5 -66.1421 1199.5 -62V356C1199.5 360.142 1196.14 363.5 1192 363.5H7.99999C3.85786 363.5 0.5 360.142 0.5 356V-62C0.5 -66.1421 3.85786 -69.5 8 -69.5Z",
    stroke: "#284993"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_44749",
    x1: 640,
    y1: 0,
    x2: 640,
    y2: 1424.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_378_44749",
    x1: 600,
    y1: -170,
    x2: 600,
    y2: 1260.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_44749"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -62C0 -66.4183 3.58172 -70 8 -70H1192C1196.42 -70 1200 -66.4183 1200 -62V356C1200 360.418 1196.42 364 1192 364H7.99999C3.58171 364 0 360.418 0 356V-62Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_378_44749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 364,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroShapes);
export default __webpack_public_path__ + "static/media/HeroShapes.f6378f43dcff425295f4608a80434398.svg";
export { ForwardRef as ReactComponent };